// eslint-disable-next-line import/no-extraneous-dependencies -- we should not use IntlMessageFormat, instead, new crowdin keys should use them inside themselves
import { IntlMessageFormat } from 'intl-messageformat';

export const addMonthToDate = (date: Date, amount: number) => {
  return new Date(date.setMonth(date.getMonth() + amount));
};

export const formatToMonthAndYear = (
  date: Date,
  { locale }: { locale: string },
): string => {
  const formattedMonth = date.toLocaleDateString(locale, {
    month: 'long',
  });

  const formattedYear = date.toLocaleDateString(locale, {
    year: 'numeric',
  });

  return `${formattedMonth} ${formattedYear}`;
};

export const formatHour = (
  dateParam: Date | string | undefined,
  {
    locale,
    omitMinutesWhenZero = true,
    enableReplaceColonWithH = true,
  }: {
    locale: string;
    omitMinutesWhenZero?: boolean;
    enableReplaceColonWithH?: boolean;
  },
): string => {
  if (dateParam) {
    try {
      const date = new Date(dateParam);
      if (omitMinutesWhenZero && date.getMinutes() === 0) {
        const jj = new IntlMessageFormat('{date, date, ::jj}', locale).format({
          date,
        });
        if (jj === date.getHours().toString().padStart(2, '0')) {
          return `${jj}h`;
        }
        return jj as string;
      }

      const jjmm = new IntlMessageFormat('{date, date, ::jjmm}', locale).format(
        {
          date,
        },
      );
      if (
        enableReplaceColonWithH &&
        jjmm ===
          `${date.getHours().toString().padStart(2, '0')}:${date
            .getMinutes()
            .toString()
            .padStart(2, '0')}`
      ) {
        return jjmm.replace(':', 'h');
      }
      return jjmm as string;
    } catch (e) {
      return '-';
    }
  }
  return '-';
};

export const formatDate = (
  date: Date | string | undefined,
  { locale }: { locale: string },
): string => {
  if (date) {
    try {
      return new IntlMessageFormat('{date, date, ::yyyyMMdd}', locale).format({
        date: new Date(date),
      }) as string;
    } catch (e) {
      return '-';
    }
  }
  return '-';
};

export const formatDateHour = (
  dateHour: Date | string | undefined,
  {
    separator = ' - ',
    ...options
  }: { separator?: string } & Parameters<typeof formatHour>[1],
): string => {
  const date = formatDate(dateHour, options);
  const hour = formatHour(dateHour, options);

  if (date !== '-' && hour !== '-') {
    return `${date}${separator}${hour}`;
  }
  return '-';
};

export function getFormattedTime(
  date: string | Date,
  { locale }: { locale: string },
): string {
  return new IntlMessageFormat('{date, date, ::jjmm}', locale).format({
    date: new Date(date),
  }) as string;
}

export const getLastDateTimeOfMonth = (year: number, month: number) => {
  const lastDayOfMonth = new Date(year, month + 1, 0);
  const lastDate = lastDayOfMonth.getDate();
  const lastHour = 23;
  const lastMinute = 59;
  const lastSecond = 59;
  const lastDateTime = new Date(
    year,
    month,
    lastDate,
    lastHour,
    lastMinute,
    lastSecond,
  );
  return lastDateTime;
};

export function getMaxAndMinDateLimit(
  selectedDate: Date,
  maxDateSelection: Date,
  minDateSelection: Date,
) {
  const currenDateAfterLimit = selectedDate && selectedDate > maxDateSelection;
  const currenDateBeforeLimit = selectedDate && selectedDate < minDateSelection;

  return {
    currenDateAfterLimit,
    currenDateBeforeLimit,
  };
}
